(function () {
    "use strict";
    realmCommerceApp.factory("localstorageService", LocalstorageService);

    /*@ngInject*/
    function LocalstorageService($localStorage) {
        var service = {
            data: {
                checkoutPaymentOption: $localStorage.payment_option,
                checkoutTermsChecked: $localStorage.terms
            },
            addPaymentOption: addPaymentOption,
            checkTerms: checkTerms
        }
        return service;

        function addPaymentOption(value) {
            $localStorage.payment_option = value;
        }

        function checkTerms(value) {
            $localStorage.terms = value;
        }


    }
})();


// WEBPACK FOOTER //
// ./static/js/app/services/localstorage.service.js